import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { userSelector } from '@src/selectors/app'
import { useActiveSubscriptions } from '@src/hooks/useActiveSubscriptions.ts'
import { useStorageValue } from '@utils/storage/mmkv'
import { Storage } from '@utils'

export const useUhcSubscriptionExpiredModal = () => {
  const user = useSelector(userSelector)
  const activeSubscriptions = useActiveSubscriptions()
  const [modalClosed, setModalClosed] = useStorageValue<boolean>(
    `${Storage.UHC_SUBSCRIPTION_EXPIRED_MODAL_CLOSED_KEY}_${user?.id}`,
  )

  const activeUhcSubscriptions = activeSubscriptions.filter((subscription) => {
    return subscription.primaryProduct.uhc
  })

  const showModal =
    user?.uhcMember &&
    activeSubscriptions.length > 0 &&
    activeUhcSubscriptions.length === 0 &&
    !modalClosed

  useEffect(() => {
    if (modalClosed && activeUhcSubscriptions.length > 0) {
      setModalClosed(false)
    }
  }, [activeUhcSubscriptions.length, modalClosed, setModalClosed])

  return { showModal, setModalClosed }
}
